import React from 'react';
import Layout from '../components/Layout';
import { StaticQuery, graphql } from 'gatsby';
import { BlogPostPreview } from '../components/blog-post-preview';

const BlogPage = () => (
  <Layout>
    <div className="section">
      <div className="container">
        <h1 className="title is-1 has-text-centered">Блог</h1>
        <StaticQuery
          query={graphql`
            query {
              posts: allContentfulBlogPost(sort: { fields: [date], order: DESC }) {
                edges {
                  node {
                    title
                    intro {
                      childMarkdownRemark {
                        html
                      }
                    }
                    slug
                  }
                }
              }
            }
          `}
          render={(data) => {
            return data.posts.edges.map(({ node }) => (
              <div style={{ marginBottom: '1rem' }} key={node.id}>
                <BlogPostPreview
                  title={node.title}
                  content={node.intro}
                  href={`/blog/${node.slug}/`}
                />
                <hr />
              </div>
            ));
          }}
        />
      </div>
    </div>
  </Layout>
);

export default BlogPage;
